module.exports = __webpack_public_path__ + "static/media/1POLICY38.addb7a3b.jpg";